import { Segment, SegmentContent, SegmentHeader } from '@/platform/ui';
import { usePage } from '@inertiajs/react';
import SignhostTransactionCard from './components/SignhostTransactionCard';
import EmployeeShowLayout from './layouts/EmployeeShowLayout';

const AuthorisationView = () => {
    const { employee } = usePage().props;

    const transactions = employee?.signhost_transactions ?? [];

    return (
        <>
            {transactions.length === 0 ? (
                <Segment>
                    <SegmentHeader header='Machtigingen' />
                    <SegmentContent>
                        <p className='text-sm text-gray-500'>
                            Deze werknemer heeft nog geen machtigingen.
                        </p>
                    </SegmentContent>
                </Segment>
            ) : (
                transactions.map(transaction => (
                    <SignhostTransactionCard
                        key={transaction.id}
                        transaction={transaction}
                    />
                ))
            )}
        </>
    );
};

AuthorisationView.layout = page => (
    <EmployeeShowLayout>{page}</EmployeeShowLayout>
);

export default AuthorisationView;
